import React from 'react';
import styled from 'styled-components';
import { LinkWrap } from '../../home/shared/heroNew/shared/BottomText/components';
import {
  breakpointsMinWidth,
  blackRGBA,
  whiteRGBA,
  HigherEdBorder,
  white,
} from '../../../../../common/styling';

const OrganizationDiv = styled.div`
  border: 1px solid ${HigherEdBorder};
  grid-area: span 1 / span 1 / span 1 / span 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in;
  background: ${white};
  &:hover {
    scale: 1.03;
    z-index: 4;
    border-top: 1px solid ${whiteRGBA(0.5)};
    border-left: 1px solid ${whiteRGBA(0.5)};
    border-radius: 8px;
    box-shadow: 5px 5px 20px ${blackRGBA(0.5)};

    @media ${breakpointsMinWidth.tabletSm} {
      box-shadow: 10px 15px 50px ${blackRGBA(0.5)};
    }
  }
  max-width: 50%;
  padding: 24px 14px;
  max-height: 92px;
  min-width: 50%;

  @media ${breakpointsMinWidth.tabletSm} {
    max-width: 25%;
    padding: 24px 14px;
    max-height: 90px;
    min-width: 25%;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    max-width: 25%;
    padding: 24px 32px;
    max-height: 96px;
    min-width: 25%;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    max-width: 25%;
    padding: 24px 36px;
    max-height: 110px;
    min-width: 25%;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    max-width: 20%;
    padding: 32px;
    max-height: 135px;
    min-width: 20%;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    min-width: 317px;
  }
`;

const OrganizationImage = styled.img`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 88px;

  @media ${breakpointsMinWidth.tabletSm} {
    max-height: 86px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    max-height: 92px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    max-height: 105px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    max-height: 130px;
  }
`;

const Organization = ({ url, imgUrl }) => {
  return (
    <OrganizationDiv>
      <LinkWrap target="_blank" href={url}>
        <OrganizationImage src={imgUrl} />
      </LinkWrap>
    </OrganizationDiv>
  );
};

export default Organization;
